import styled from 'styled-components';
import MuiCardActions from "@material-ui/core/CardActions";

export const StyledMuiCardActions = styled(MuiCardActions)`
  && {
    justify-content: center;
    padding: 50px 30px;
  }
`;
